function LoadView(view) {
  return () =>
    import(
      /* webpackChunkName: "view-[request]" */ `@/html/subpage/board/${view}.vue`
    );
}

const boardRoutes = [
  /* 알림마당 */

  // 공지사항
  {
    path: '/noticelist',
    name: 'noticelist',
    component: LoadView('noticeList'),
    meta: {
      category: ['알림마당', '공지사항'],
    },
  },
  // 공지사항 - 상세
  {
    path: '/noticeview',
    name: 'noticeview',
    component: LoadView('noticeView'),
    meta: {
      category: ['알림마당', '공지사항'],
    },
  },

  // 자주 묻는 질문
  {
    path: '/faqview',
    name: 'faqview',
    component: LoadView('faqView'),
    meta: {
      category: ['알림마당', '자주 묻는 질문'],
    },
  },

  // 1:1 문의
  {
    path: '/customer',
    name: 'customer',
    component: () => {
      const link =
        'https://www.insiseol.or.kr/main/bbs/bbsMsgList.do?bcd=voc&cate1=24&instdiv=&catediv=&contentdiv=&keyfield=title&keyword=';
      if (/Mobi/i.test(window.navigator.userAgent)) {
        location.href = link;
      } else {
        window.open(link, '_blank');
      }
    },
    meta: {
      category: ['알림마당', '1:1 문의'],
    },
  },
];

export default boardRoutes;
